import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {

  @Input() parent: FormGroup
  @Input() disabled = false

  @Output() save = new EventEmitter<any>()

  onClick() {
    if (this.disabled) {
      return
    }
    this.save.emit()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/button/button.component.ts